'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.subscriptionProfileWidget = function (subscriptionModel) {
	return mmWidgets.each(this, function () {
		const widget = this,
			type = widget.attr('data-mm-subscription-profile');

		subscriptionModel.addEventListener('subscribed expiredSubscription notRegistered', function (profile) {
			if (type && profile && profile[type]) {
				widget.removeClass('hidden');
				widget.text(profile[type]);
			}
		});

		subscriptionModel.addEventListener('not-authenticated authenticating', function () {
			widget.addClass('hidden');
		});

	});
};
